// extracted by css-extract-rspack-plugin
export default {"errorDate":"Rc0yP4dQJXMFsyos"};